const organization_details = {
    departments: {
        leader: 'Responsable',
        leaders: 'Responsables du département',
        led_departments: 'Départements dirigés',
        edit_leaders: 'Gérer les responsables',
        add_leader: 'Ajouter',
        remove_leader: 'Retirer',
        no_leaders: 'Aucun responsable',
        local: 'Gestion locale',
        managed_members: 'Membres du périmètre géré',
        leader_scope_hint: 'Gérez les affectations de vos départements et sous-départements.',
        leader_permission_hint: 'Les responsables gèrent les affectations de leurs départements et sous-départements, sans modifier les rôles ni la hiérarchie.',
        primary_synced: 'Le département principal est géré par Feishu.',
        status_active: 'Actif',
        status_suspended: 'Suspendu',
        status_departed: 'Parti',
        status_pending: 'Activation en attente',
        search: 'Rechercher',
        previous_page: 'Page précédente',
        next_page: 'Page suivante',
        directory_title: 'Membres de l’organisation',
        member_name: 'Membre',
        search_members: 'Rechercher par nom ou identifiant',
        include_descendants: 'Inclure les sous-services',
        no_members: 'Aucun membre correspondant.',
        all_members: 'Tous les membres',
        all_departments: 'Tous les services',
        edit_member: 'Modifier les services',
        add_child: 'Ajouter un sous-service',
        expand_department: 'Développer {{name}}',
        collapse_department: 'Réduire {{name}}',
        title: 'Départements',
        description: 'Gérez les départements et les affectations des membres de cette organisation.',
        create: 'Créer un département',
        edit: 'Modifier le département',
        name: 'Nom du département',
        parent: 'Département parent',
        root: 'Aucun département parent',
        id: 'ID du département',
        members: 'Départements des membres',
        member_id: 'ID utilisateur du membre',
        primary: 'Département principal',
        none: 'Non défini',
        assignments: 'Affectations aux départements',
        no_assignments: 'Aucune affectation pour le moment.',
        assignment_hint: 'Affectez des départements locaux et éventuellement un département principal. Les affectations de l’annuaire sont en lecture seule.',
        empty: 'Aucun département pour le moment.',
        readonly: 'Vous pouvez consulter les départements et vos affectations. Contactez un administrateur pour les modifier.',
        load_error: 'Impossible de charger les données. Réessayez.',
        mutation_error: 'Enregistrement impossible. Vérifiez vos droits, votre appartenance et la hiérarchie des départements.',
        loading: 'Chargement…',
        synced: 'Géré par l’annuaire',
        choose: 'Rechercher des départements',
        organizations_title: 'Organisations et départements',
        organizations_description: 'Choisissez une organisation pour consulter ou gérer ses départements.',
        no_organizations: 'Vous ne faites partie d’aucune organisation. Contactez un administrateur.',
        organization: 'Organisation actuelle',
        choose_organization: 'Choisissez une organisation',
        delete_title: 'Supprimer le département',
        delete_description: 'Supprimer « {{name}} » ? Déplacez d’abord ses membres et sous-départements.',
    },
    directory: {
        leaders_label: 'Responsabilités de département',
        local_department_leader: 'Responsable attribué localement',
        status_active: 'Actif',
        status_suspended: 'Suspendu',
        status_departed: 'Parti',
        status_pending: 'Activation en attente',
        profiles_label: 'Profils sources',
        primary_label: 'Changements de département principal',
        deactivated_label: 'Identités désactivées',
        reactivated_label: 'Identités réactivées',
        lifecycle_notice: 'Attributions de rôles conservées : {{count}}. La réactivation rétablit les autorisations précédentes.',
        title: 'Annuaire Feishu',
        description: 'Importez les départements et membres dans cette organisation via un connecteur Feishu.',
        identity_notice: 'Utilisez un connecteur avec le provisionnement d’annuaire activé. Modifier l’identité d’un connecteur existant nécessite une migration des comptes.',
        connector: 'ID du connecteur Feishu',
        preview: 'Prévisualiser la synchronisation',
        preview_title: 'Aperçu de synchronisation',
        preview_description: 'Vérifiez l’annuaire avant l’import. S’il change, générez un nouvel aperçu.',
        import: 'Confirmer la synchronisation',
        success: '{{departments}} départements et {{users}} membres importés ; {{createdUsers}} comptes créés. Suppression de {{removedDepartments}} départements, {{removedMemberships}} adhésions et {{removedAssignments}} affectations.',
        failure: 'Lecture ou import impossible. Vérifiez les droits et la visibilité du connecteur, puis générez un nouvel aperçu.',
        behavior_title: 'Mode d’import',
        mode: 'Synchroniser les noms, avatars, départements et départements principaux. Les membres absents ou inactifs perdent uniquement l’accès à cette organisation ; les rôles, affectations locales, comptes globaux et autres identités sont conservés. L’e-mail et le téléphone restent des données sources, sans devenir des identifiants de connexion.',
        limits: 'Par import : 1000 départements, 5000 utilisateurs, 10000 affectations ; lecture limitée à 60 secondes. Les imports incomplets ou trop volumineux sont refusés.',
        counts: '{{departments}} départements · {{users}} membres',
        departments_label: 'Départements',
        members_label: 'Adhésions aux organisations',
        assignments_label: 'Affectations aux départements',
        item: 'Élément',
        added: 'Ajouter',
        updated: 'Mettre à jour',
        removed: 'Supprimer',
        cleanup_notice: 'Synchroniser les noms, avatars, départements et départements principaux. Les membres absents ou inactifs perdent uniquement l’accès à cette organisation ; les rôles, affectations locales, comptes globaux et autres identités sont conservés. L’e-mail et le téléphone restent des données sources, sans devenir des identifiants de connexion.',
        conflicts_title: '{{count}} conflits bloquent la synchronisation. Résolvez les dépendances locales puis relancez l’aperçu.',
        removals_title: 'Exemples de suppressions (20 maximum par catégorie)',
        local_child_department: 'Sous-département local',
        unowned_assignment: 'Affectation locale ou ancienne sans provenance prouvée',
        local_member_roles: 'Le membre a des rôles attribués localement',
        unlinked_identity: 'L’identité du répertoire a été dissociée',
    },
    page_title: "Détails de l'organisation",
    delete_confirmation: 'Une fois supprimée, tous les membres perdront leur adhésion et leurs rôles dans cette organisation. Cette action ne peut pas être annulée.',
    organization_id: "Identifiant de l'organisation",
    settings_description: 'Les organisations représentent les équipes, les clients professionnels et les entreprises partenaires qui peuvent accéder à vos applications.',
    name_placeholder: "Le nom de l'organisation, pas nécessairement unique.",
    description_placeholder: "Une description de l'organisation.",
    member: 'Membre',
    member_other: 'Membres',
    add_members_to_organization: "Ajouter des membres à l'organisation {{name}}",
    add_members_to_organization_description: "Trouvez les utilisateurs appropriés en recherchant leur nom, e-mail, téléphone ou identifiant d'utilisateur. Les membres existants ne sont pas affichés dans les résultats de la recherche.",
    add_with_organization_role: "Ajouter avec le(s) rôle(s) dans l'organisation",
    user: 'Utilisateur',
    application: 'Application',
    application_other: 'Applications',
    add_applications_to_organization: "Ajouter des applications à l'organisation {{name}}",
    add_applications_to_organization_description: "Trouvez les applications appropriées en recherchant l'ID de l'application, le nom ou la description. Les applications existantes ne sont pas affichées dans les résultats de la recherche.",
    at_least_one_application: 'Au moins une application est requise.',
    remove_application_from_organization: "Supprimer l'application de l'organisation",
    remove_application_from_organization_description: "Une fois supprimée, l'application perdra son association et ses rôles dans cette organisation. Cette action ne peut pas être annulée.",
    search_application_placeholder: "Rechercher par ID, nom ou description de l'application",
    roles: "Rôles de l'organisation",
    authorize_to_roles: 'Autoriser {{name}} à accéder aux rôles suivants :',
    edit_organization_roles: "Modifier les rôles de l'organisation",
    edit_organization_roles_title: "Modifier les rôles de l'organisation de {{name}}",
    remove_user_from_organization: "Retirer l'utilisateur de l'organisation",
    remove_user_from_organization_description: "Une fois retiré, l'utilisateur perdra son adhésion et ses rôles dans cette organisation. Cette action ne peut pas être annulée.",
    search_user_placeholder: "Rechercher par nom, e-mail, téléphone ou identifiant d'utilisateur",
    at_least_one_user: 'Au moins un utilisateur est requis.',
    organization_roles_tooltip: 'Les rôles attribués au {{type}} au sein de cette organisation.',
    custom_data: 'Données personnalisées',
    custom_data_tip: "Les données personnalisées sont un objet JSON qui peut être utilisé pour stocker des données supplémentaires associées à l'organisation.",
    invalid_json_object: 'Objet JSON non valide.',
    branding: {
        name: 'Image de marque',
        description: "Personnalisez votre expérience de connexion au niveau de l'organisation.",
        organization_level_sie: "Expérience de connexion au niveau de l'organisation",
        organization_level_sie_switch: "Activez l'expérience de connexion au niveau de l'organisation et définissez une image de marque spécifique. Si elle est désactivée, retour d'abord à l'expérience de connexion au niveau de l'application puis à l'expérience omni.",
        logo: "Logos de l'organisation",
        logo_tooltip: "Vous pouvez passer l'ID de l'organisation pour afficher ce logo dans l'expérience de connexion ; la version sombre du logo est nécessaire si le mode sombre est activé dans les paramètres de l'expérience de connexion omni. <a>Apprenez-en plus</a>",
    },
    jit: {
        title: 'Supply de juste-à-temps',
        description: "Les utilisateurs peuvent automatiquement rejoindre l'organisation et se voir attribuer des rôles dès leur première connexion via certaines méthodes d'authentification. Vous pouvez définir des exigences à remplir pour le supply de juste-à-temps.",
        email_domain: 'Approvisionnement de domaine de courrier électronique',
        email_domain_description: "Les nouveaux utilisateurs qui s'inscrivent avec leur adresse e-mail vérifiée ou via une connexion sociale avec des adresses e-mail vérifiées rejoindront automatiquement l'organisation. <a>Apprenez-en plus</a>",
        email_domain_placeholder: 'Entrez des domaines de courrier électronique pour le supply de juste-à-temps',
        invalid_domain: 'Domaine non valide',
        domain_already_added: 'Domaine déjà ajouté',
        sso_enabled_domain_warning: "Vous avez saisi un ou plusieurs domaines de courrier électronique associés à un SSO d'entreprise. Les utilisateurs avec ces e-mails suivront le flux SSO standard et ne seront pas provisionnés pour cette organisation à moins que le provisionnement SSO d'entreprise ne soit configuré.",
        enterprise_sso: "Provisionnement SSO d'entreprise",
        no_enterprise_connector_set: "Vous n'avez encore configuré aucun connecteur SSO d'entreprise. Ajoutez d'abord des connecteurs pour activer le provisionnement SSO d'entreprise. <a>Configurer</a>",
        add_enterprise_connector: "Ajouter un connecteur d'entreprise",
        enterprise_sso_description: "Les nouveaux utilisateurs ou les utilisateurs existants se connectant via le SSO d'entreprise pour la première fois rejoindront automatiquement l'organisation. <a>Apprenez-en plus</a>",
        organization_roles: "Rôles d'organisation par défaut",
        organization_roles_description: "Attribuez des rôles aux utilisateurs lors de leur adhésion à l'organisation via le supply de juste-à-temps.",
    },
    mfa: {
        title: 'Authentification multi-facteurs (MFA)',
        tip: "Lorsque la MFA est requise, les utilisateurs sans MFA configurée seront rejetés lorsqu'ils essaient d'échanger un jeton d'organisation. Ce paramètre n'a pas d'incidence sur l'authentification des utilisateurs.",
        description: 'Exigez que les utilisateurs configurent une authentification multi-facteurs pour accéder à cette organisation.',
        no_mfa_warning: "Aucune méthode d'authentification multi-facteurs n'est activée pour votre locataire. Les utilisateurs ne pourront pas accéder à cette organisation tant qu'au moins une <a>méthode d'authentification multi-facteurs</a> n'est pas activée.",
    },
};
export default Object.freeze(organization_details);
